<template>
  <div>
    <!-- boldplay settings -->
    <p class="title is-5">Boldplay settings</p>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Lobby url</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="boldplaySettings.lobbyUrl" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">OperatorId</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="boldplaySettings.operatorId" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Brand</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="boldplaySettings.brand" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label">
      </div>
      <div class="field-body">
        <div class="field is-grouped">
          <div class="control">
            <button @click="save" class="button is-primary">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import boldplayService from '../../../../services/boldplay.service';

  export default {
    name: 'client-settings-boldplay',
    data() {
      return {
        boldplaySettings: {
        }
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    async mounted() {
      this.boldplaySettings = await boldplayService.getSettingsByClient(this.clientId);
    },
    methods: {
      async save() {
        await boldplayService.save(this.clientId, this.boldplaySettings);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/boldplay.vue